import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { NotificationService } from '../../services/notification.service';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {

  constructor(
    private router: Router,
    private notificationService: NotificationService
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 400 || error.status === 500) {
          // 400 hatası alındığında
          let errorMessage = error.error || 'Beklenmeyen hata';
          const errorTitle = error.error?.title || '';
          if (!errorMessage) errorMessage = 'Beklenmeyen hata.'
          this.notificationService.showError(`Status: ${error.status} \nHata: ${errorMessage}`, { title: errorTitle });
          console.error(`error response`, error);
        }

        if (error.status === 401 && !error.url?.includes('api/Auth')) {
          // 401 hatası alındığında
          console.warn('Unauthorized access - redirecting to login.', error);
          sessionStorage.removeItem("token")
          location.href = '/login-form';
        }

        // Hata oluştuğunda hata bilgisini üst katmana iletmek için throwError kullanılır
        return throwError(() => error);
      })
    );
  }
}
